"use client";

import {
  getOrderedActiveMarkets,
  normalizeOddsDisplayToggles,
} from "@/utils/dreamnOddsDisplayToggle";
import { HdpCells, OuCells, X2Cells } from "./DreamnOddsMarketCells";

const ODDS_TYPE_LABEL = {
  hdc: "HDP",
  ou: "Tài xỉu",
  x2: "1x2",
};

function OddsTypeCaption({ marketKey, children }) {
  const label = ODDS_TYPE_LABEL[marketKey];
  if (!label) return children;

  return (
    <div className="flex min-w-0 w-full flex-col items-center gap-0.5">
      <span className="text-[10px] md:text-[11px] font-semibold leading-none text-[var(--theme-text-muted)]">
        {label}
      </span>
      <div className="flex min-w-0 w-full justify-center">{children}</div>
    </div>
  );
}

function PeriodToggleButton({ periodLabel, onTogglePeriod }) {
  return (
    <div
      className={`match cursor-pointer flex items-center justify-center text-white text-xs md:text-sm font-bold w-[25px] md:w-[30px] h-5 md:h-[25px] rounded-sm ${
        periodLabel === "FT"
          ? "kbv-period-ft-navy-slate"
          : "kbv-period-ht-navy-slate"
      }`}
      onClick={onTogglePeriod}
    >
      {periodLabel || "HT"}
    </div>
  );
}

export default function DreamnMatchOdds({
  homeHandicap,
  handicapValue,
  awayHandicap,
  homeHandicapTrend,
  awayHandicapTrend,
  overOdds,
  overUnderValue,
  underOdds,
  overTrend,
  underTrend,
  home1x2,
  draw1x2,
  away1x2,
  home1x2Trend,
  draw1x2Trend,
  away1x2Trend,
  showHdc,
  showOu,
  showX2,
  periodLabel,
  onTogglePeriod,
}) {
  const order = getOrderedActiveMarkets(
    normalizeOddsDisplayToggles({ hdc: showHdc, ou: showOu, x2: showX2 }),
  );

  const oddsGridCols =
    order.length >= 3 ? "grid-cols-3" : order.length === 2 ? "grid-cols-2" : "grid-cols-1";

  const renderMarket = (key) => {
    if (!key) return null;
    if (key === "hdc") {
      return (
        <HdpCells
          homeHandicap={homeHandicap}
          handicapValue={handicapValue}
          awayHandicap={awayHandicap}
          homeHandicapTrend={homeHandicapTrend}
          awayHandicapTrend={awayHandicapTrend}
        />
      );
    }
    if (key === "ou") {
      return (
        <OuCells
          overOdds={overOdds}
          overUnderValue={overUnderValue}
          underOdds={underOdds}
          overTrend={overTrend}
          underTrend={underTrend}
        />
      );
    }
    if (key === "x2") {
      return (
        <X2Cells
          home1x2={home1x2}
          draw1x2={draw1x2}
          away1x2={away1x2}
          home1x2Trend={home1x2Trend}
          draw1x2Trend={draw1x2Trend}
          away1x2Trend={away1x2Trend}
        />
      );
    }
    return null;
  };

  return (
    <div className="flex w-full min-w-0 flex-col md:gap-0">
      <div className="mb-1 flex w-full shrink-0 justify-end pr-0.5 md:mb-0 md:hidden">
        <PeriodToggleButton periodLabel={periodLabel} onTogglePeriod={onTogglePeriod} />
      </div>

      <div className="flex w-full min-w-0 flex-row items-center gap-0 md:gap-2">
        <div className="odds-edge shrink-0 w-4 md:w-20" aria-hidden />

        <div className="odds-data flex min-w-0 flex-1 justify-stretch overflow-x-visible overflow-y-visible md:ml-2">
          <div
            className={`grid w-full min-w-0 max-w-full items-end gap-2 px-0 md:gap-2.5 md:px-0.5 ${oddsGridCols}`}
          >
            {order.map((key) => (
              <div
                key={key}
                className="flex min-w-0 w-full justify-center px-0 md:min-w-0 md:px-1"
              >
                <OddsTypeCaption marketKey={key}>
                  {renderMarket(key)}
                </OddsTypeCaption>
              </div>
            ))}
          </div>
        </div>

        <div className="odds-tail flex shrink-0 w-4 items-center justify-center md:w-20">
          <div className="hidden md:flex md:w-full md:items-center md:justify-center">
            <PeriodToggleButton periodLabel={periodLabel} onTogglePeriod={onTogglePeriod} />
          </div>
        </div>
      </div>
    </div>
  );
}
